import { protectedRoute } from "@/lib/protectedRoute";
import { Visit } from "@/pages/Visit";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/visits/$visitId")({
  component: Visit,
  beforeLoad: () => {
    return protectedRoute({ location: window.location });
  },
});
